// Localized release dates. Input "YYYY-MM-DD" is a calendar date: format it in UTC so it never shifts by a day.
const LOCALES = { it: "it-IT", en: "en-US", es: "es-ES", pt: "pt-BR" };

export const formatDate = (iso, lang) => {
  if (!iso || !/^\d{4}-\d{2}-\d{2}/.test(iso)) return iso || "";
  const d = new Date(`${iso.slice(0, 10)}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat(LOCALES[lang] || "it-IT", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }).format(d);
};
